import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

// Wohnmobil bis 7.5m
// Source: https://www.flaticon.com/free-icon/motorhome_3175773?term=motorhome&page=1&position=16&origin=search&related_id=3175773

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesCamperComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        enableBackground="new 0 0 512 512"
        height="512"
        id="Capa_1"
        viewBox="0 0 512 512"
        width="512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path d="m459.872 80.044h-262.841v-6.486c0-27.508-22.379-49.887-49.887-49.887h-41.524c-27.508 0-49.887 22.379-49.887 49.887v6.486h-3.605c-28.744 0-52.128 23.384-52.128 52.128l.001 261.615c0 31.41 25.246 57.017 56.509 57.639 8.242 21.552 29.127 36.903 53.541 36.903 24.402 0 45.279-15.337 53.528-36.874h171.608c8.25 21.536 29.126 36.874 53.528 36.874 24.403 0 45.279-15.337 53.529-36.874h29.009c15.645 0 28.373-12.728 28.373-28.373v-102.783c0-.187-.022-.368-.028-.553.154-2.809-.476-5.653-1.905-8.187l-52.213-92.626h31.812c19.106 0 34.661-15.544 34.674-34.651l.034-52.1v-.01c0-28.744-23.384-52.128-52.128-52.128zm-374.139-6.486c0-10.965 8.921-19.887 19.887-19.887h41.525c10.965 0 19.887 8.921 19.887 19.887v6.486h-81.299zm-55.732 320.229v-59.861h162.365v87.529h-25.82c-4.568-27.061-28.155-47.743-56.495-47.743-28.235 0-51.75 20.53-56.441 47.443-13.339-1.97-23.609-13.491-23.609-27.368zm241.496 27.668h-49.131v-202.515h49.131zm-161.446 36.874c-15.058 0-27.309-12.25-27.309-27.309 0-15.058 12.25-27.308 27.309-27.308 15.058 0 27.308 12.25 27.308 27.308s-12.251 27.309-27.308 27.309zm278.665 0c-15.058 0-27.308-12.25-27.308-27.309 0-15.058 12.25-27.308 27.308-27.308s27.309 12.25 27.309 27.308c-.001 15.058-12.251 27.309-27.309 27.309zm80.91-36.874h-24.416c-4.568-27.061-28.155-47.743-56.495-47.743s-51.927 20.683-56.495 47.743h-30.725v-87.529h168.13v87.529zm-99.641-117.53-.001-84.992h41.059l47.91 84.992zm111.981-119.663c-.002 2.576-2.099 4.671-4.674 4.671h-122.309c-1.492 0-2.961.222-4.363.648-2.336.71-4.486 1.987-6.244 3.745s-3.035 3.908-3.745 6.244c-.426 1.402-.648 2.871-.648 4.362v99.993h-38.487v-85.896c0-16.041-12.02-29.091-26.793-29.091h-55.545c-14.773 0-26.792 13.05-26.792 29.091v85.896h-162.366v-171.754c0-12.201 9.926-22.128 22.128-22.128h407.744c12.2 0 22.125 9.924 22.128 22.124z" />
          <path d="m128.827 218.923h-37.553c-8.284 0-15 6.716-15 15s6.716 15 15 15h37.552c8.284 0 15-6.716 15-15s-6.715-15-14.999-15z" />
        </g>
      </svg>
    </SvgIcon>
  );
};

IconVehiclesCamperComponent.displayName = 'IconVehiclesCamper';

const IconVehiclesCamper = React.memo(IconVehiclesCamperComponent);

export default IconVehiclesCamper;
